export default __webpack_public_path__ + "static/personality-collaborative-light-5ee5d896f1a0e95580488b22be9b38ce6b93920c91633591ede17eeff4102358.png";